import {
  type TableColumnFormatEnum,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import { pipe } from 'fp-ts/function';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';
import { maybeWrapNonEmptyWithLink } from './helpers/maybeWrapWithLink';

export const renderEnumCell = <TRow,>(
  format: TableColumnFormatEnum<TRow, unknown>,
  { row, context, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const value = getValueFromKeyOfType(row, format.field);
  const content = format.options[`${value}`] ?? `${value ?? ''}`;

  return {
    content: pipe(
      content,
      maybeWrapNonEmptyWithLink(
        row,
        severity !== null,
        format.createLinkProps,
        !context.disableLinks,
      ),
    ),
  };
};
